import React from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "./styles/editModal.module.scss";

const DetailsModal = ({ handleDeleteModalClose, data }) => {
  return (
    <Modal
      show={true}
      onHide={handleDeleteModalClose}
      centered
      size="lg"
      className={styles.editModal}
    >
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          Report Details
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className={styles.modalBody}>
        {data && (
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">User Name:</label>
              <p className="form-control-plaintext">{data.user?.name || 'N/A'}</p>
            </div>
            
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Email:</label>
              <p className="form-control-plaintext">{data.user?.email || 'N/A'}</p>
            </div>
            
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Phone:</label>
              <p className="form-control-plaintext">{data.user?.mobile_no || 'N/A'}</p>
            </div>
            
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Report Type:</label>
              <p className="form-control-plaintext">{data.report_type || 'N/A'}</p>
            </div>
            
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Status:</label>
              <p className="form-control-plaintext">
                <span className={`badge ${data.status === 'pending' ? 'bg-warning' : 'bg-success'}`}>
                  {data.status || 'N/A'}
                </span>
              </p>
            </div>
            
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Date:</label>
              <p className="form-control-plaintext">
                {data.created_at ? new Date(data.created_at).toLocaleDateString() : 'N/A'}
              </p>
            </div>
            
            <div className="col-12 mb-3">
              <label className="form-label fw-bold">Description:</label>
              <div className="border p-3 rounded bg-light">
                <p className="mb-0">{data.description || 'No description provided'}</p>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      
      <Modal.Footer className={styles.modalFooter}>
        <Button 
          variant="secondary" 
          onClick={handleDeleteModalClose}
          className={styles.cancelBtn}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DetailsModal;